import { render } from "./LeftSideBarLayout.vue?vue&type=template&id=2a28b869"
import script from "./LeftSideBarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSideBarLayout.vue?vue&type=script&lang=js"

import "./LeftSideBarLayout.vue?vue&type=style&index=0&id=2a28b869&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__